var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSquareWrench(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.604 20.796H19.57c.78 0 1.413-.634 1.413-1.414V4.414c0-.78-.633-1.414-1.413-1.414H4.604c-.78 0-1.414.634-1.414 1.414v14.968c0 .78.633 1.414 1.414 1.414zM4.389 4.414c0-.118.096-.214.215-.214H19.57c.119 0 .214.096.214.214v14.968a.214.214 0 01-.214.214H4.604a.215.215 0 01-.215-.214V4.414zm12.985 6.959c-.911.911-2.388.984-3.634.285a1.045 1.045 0 01-.036.038l-5.693 5.693a.997.997 0 01-1.414 0 1 1 0 010-1.414l5.693-5.693.003-.003c-.8-1.277-.757-2.84.195-3.792.82-.82 2.078-.962 3.217-.488l-2.166 2.166a.627.627 0 000 .887l1.27 1.27a.627.627 0 00.887 0l2.165-2.166c.474 1.138.326 2.404-.487 3.217z"
  })));
}

export default SvgSquareWrench;